
import {
  Mixins, Component, Watch,
} from 'vue-property-decorator';
import SwitchWithConfirm from '@/components/SwitchWithConfirm.vue';
import AttachmentWithStatus from '@/components/AttachmentWithStatus.vue';
import UpdateButton from '@/components/UpdateButton.vue';
import TextFieldWithConfirm from '@/components/TextFieldWithConfirm.vue';
import SlotWithConfirm from '@/components/SlotWithConfirm.vue';
import Editor from '@/components/Editor.vue';
import { BoxStatusType, Lead } from '@/types';
import {
  getLeadCustomValueText,
  getLeadCustomValueBoolean,
  getLeadCustomValueDate,
} from '@/helpers';
import UtilsMixin from '@/mixins/UtilsMixin.vue';
import EditConnectionDialogMixin from '@/mixins/EditConnectionDialogMixin.vue';

@Component({
  components: {
    SwitchWithConfirm,
    AttachmentWithStatus,
    UpdateButton,
    TextFieldWithConfirm,
    SlotWithConfirm,
    Editor,
  },
})
export default class EditMUP2Dialog extends Mixins(EditConnectionDialogMixin, UtilsMixin) {
  dicoVisuraCamerale: BoxStatusType = 'todo'
  dicoVisuraCameraleNotes: string | null | undefined = null
  dicoElettricaDate: Date | null = null

  inverter: BoxStatusType = 'todo'
  batteriaAC: BoxStatusType = 'todo'
  spiEsterna: BoxStatusType = 'todo'
  autotestNotes: string | null = null

  fotoImpianto: BoxStatusType = 'todo'
  fotoDG: BoxStatusType = 'todo'
  fotoDGAlt: string | null = null
  fotoInverter: BoxStatusType = 'todo'
  fotoInverterAlt: string | null = null
  fotoBatteria: BoxStatusType = 'todo'
  fotoBatteriaAlt: string | null = null

  docCeiModelliConformita: string | null | undefined = null
  docCeiModelliConformitaConfirmed = false
  dichMarcaModelloModuli: string | null | undefined = null
  dichMarcaModelloModuliConfirmed = false
  tecnicoAbilitato: string | null | undefined = null
  tecnicoAbilitatoConfirmed = false
  installatoreNominativo: string | null | undefined = null
  installatoreNominativoConfirmed = false
  installatoreContatti: string | null | undefined = null

  practiceNotes: string | null = null

  docsSentToPartner = false

  // Questo componente necessita che la Lead a cui è associato l'allegato sia selezionata

  // Aggiorna i campi con gli eventuali nuovi valori della Connection/Lead selezionata
  refresh() {
    console.log(`${this.constructor.name}: refresh()`); // eslint-disable-line no-console

    // Ottiene lo stato degli allegati dalla Lead associata
    if (this.currentElettricaFiglia) {
      this.dicoVisuraCamerale = (getLeadCustomValueText(this.currentElettricaFiglia, 'dicoVisuraCamerale') ?? 'todo') as BoxStatusType;
      this.dicoVisuraCameraleNotes = getLeadCustomValueText(this.currentElettricaFiglia, 'dicoVisuraCameraleNotes') ?? null;
      this.dicoElettricaDate = getLeadCustomValueDate(this.currentElettricaFiglia, 'dicoElettricaDate');

      this.inverter = (getLeadCustomValueText(this.currentElettricaFiglia, 'inverter') ?? 'todo') as BoxStatusType;
      this.batteriaAC = (getLeadCustomValueText(this.currentElettricaFiglia, 'batteriaAC') ?? 'todo') as BoxStatusType;
      this.spiEsterna = (getLeadCustomValueText(this.currentElettricaFiglia, 'spiEsterna') ?? 'todo') as BoxStatusType;
      this.autotestNotes = getLeadCustomValueText(this.currentElettricaFiglia, 'autotestNotes') ?? null;

      this.fotoImpianto = (getLeadCustomValueText(this.currentElettricaFiglia, 'fotoImpianto') ?? 'todo') as BoxStatusType;
      this.fotoDG = (getLeadCustomValueText(this.currentElettricaFiglia, 'fotoDG') ?? 'todo') as BoxStatusType;
      this.fotoDGAlt = getLeadCustomValueText(this.currentElettricaFiglia, 'fotoDGAlt') ?? null;
      this.fotoInverter = (getLeadCustomValueText(this.currentElettricaFiglia, 'fotoInverter') ?? 'todo') as BoxStatusType;
      this.fotoInverterAlt = getLeadCustomValueText(this.currentElettricaFiglia, 'fotoInverterAlt') ?? null;
      this.fotoBatteria = (getLeadCustomValueText(this.currentElettricaFiglia, 'fotoBatteria') ?? 'todo') as BoxStatusType;
      this.fotoBatteriaAlt = getLeadCustomValueText(this.currentElettricaFiglia, 'fotoBatteriaAlt') ?? null;

      this.docsSentToPartner = getLeadCustomValueBoolean(this.currentElettricaFiglia, 'docsSentToPartner') ?? false;
    }

    this.docCeiModelliConformita = (getLeadCustomValueText(this.lead, 'docCeiModelliConformita') ?? null);
    this.dichMarcaModelloModuli = (getLeadCustomValueText(this.lead, 'dichMarcaModelloModuli') ?? null);
    this.tecnicoAbilitato = (getLeadCustomValueText(this.lead, 'tecnicoAbilitato') ?? null);
    this.installatoreNominativo = (getLeadCustomValueText(this.lead, 'installatoreNominativo') ?? null);
    this.installatoreContatti = (getLeadCustomValueText(this.lead, 'installatoreContatti') ?? null);

    this.docCeiModelliConformitaConfirmed = getLeadCustomValueBoolean(this.lead, 'docCeiModelliConformitaConfirmed') ?? false;
    this.dichMarcaModelloModuliConfirmed = getLeadCustomValueBoolean(this.lead, 'dichMarcaModelloModuliConfirmed') ?? false;
    this.tecnicoAbilitatoConfirmed = getLeadCustomValueBoolean(this.lead, 'tecnicoAbilitatoConfirmed') ?? false;
    // Se non c'è un tecnico salvato propone l'assegnatario delle pratiche di
    // connessione, da confermare (OwlCaveLabs/syndesia-l2c-support#30). Non su un
    // campo già confermato: mostrerebbe come confermato un nome che nessuno ha visto.
    if (this.tecnicoAbilitato === null && !this.tecnicoAbilitatoConfirmed) {
      this.tecnicoAbilitato = this.proposedTecnicoAbilitato;
    }
    this.installatoreNominativoConfirmed = getLeadCustomValueBoolean(this.lead, 'installatoreNominativoConfirmed') ?? false;

    // Note alle pratiche
    this.practiceNotes = getLeadCustomValueText(this.lead, 'practiceNotes') ?? null;

    // Richiama il metodo del mixin
    return this.mixinRefresh();
  }

  // Il tecnico abilitato proposto finché non ne è salvato uno: l'assegnatario
  // delle pratiche di connessione, se le pratiche non sono "non applicabile".
  get proposedTecnicoAbilitato(): string | null {
    if (this.connection?.practiceAssigned === 'na') return null;
    return this.connection?.practiceAssigneeName ?? null;
  }

  onFieldUpdated(field: string, value: unknown = undefined) {
    console.log(`${this.constructor.name}: onFieldUpdated(${field})`); // eslint-disable-line no-console

    // Modifico eventuali campi collegati
    const update = {} as { [key: string]: unknown };
    switch (field) {
      case 'tecnicoAbilitatoConfirmed':
        // Se il tecnico è stato confermato, aggiorna anche il campo tecnicoAbilitato
        // perché potrebbe contenere il nome proposto.
        if (value === true) {
          update.tecnicoAbilitato = this.tecnicoAbilitato;
        } else if (getLeadCustomValueText(this.lead, 'tecnicoAbilitato') == null
          && this.tecnicoAbilitato === this.proposedTecnicoAbilitato) {
          // Togliendo la spunta il nome proposto non va salvato: lo store unisce gli
          // aggiornamenti in sospeso, quindi va sovrascritto quello della conferma.
          update.tecnicoAbilitato = null;
        }
        break;

      default:
        break;
    }
    this.$store.dispatch('updateConnectionFields', {
      fields: update,
    });

    // Richiama il metodo del mixin
    return this.mixinOnFieldUpdated(field, value);
  }

  @Watch('currentElettricaFiglia')
  onCurrentElettricaFigliaChange(val: Lead | null, oldVal: Lead | null) {
    // La figlia elettrica è stata recuperata, aggiorna i campi ottenuti da essa.
    if (oldVal === null && val !== null) {
      this.dicoVisuraCamerale = (getLeadCustomValueText(this.currentElettricaFiglia, 'dicoVisuraCamerale') ?? 'todo') as BoxStatusType;
      this.dicoVisuraCameraleNotes = getLeadCustomValueText(this.currentElettricaFiglia, 'dicoVisuraCameraleNotes') ?? null;
      this.dicoElettricaDate = getLeadCustomValueDate(this.currentElettricaFiglia, 'dicoElettricaDate');
      this.inverter = (getLeadCustomValueText(this.currentElettricaFiglia, 'inverter') ?? 'todo') as BoxStatusType;
      this.batteriaAC = (getLeadCustomValueText(this.currentElettricaFiglia, 'batteriaAC') ?? 'todo') as BoxStatusType;
      this.spiEsterna = (getLeadCustomValueText(this.currentElettricaFiglia, 'spiEsterna') ?? 'todo') as BoxStatusType;
      this.autotestNotes = getLeadCustomValueText(this.currentElettricaFiglia, 'autotestNotes') ?? null;
      this.fotoImpianto = (getLeadCustomValueText(this.currentElettricaFiglia, 'fotoImpianto') ?? 'todo') as BoxStatusType;
      this.fotoDG = (getLeadCustomValueText(this.currentElettricaFiglia, 'fotoDG') ?? 'todo') as BoxStatusType;
      this.fotoDGAlt = getLeadCustomValueText(this.currentElettricaFiglia, 'fotoDGAlt') ?? null;
      this.fotoInverter = (getLeadCustomValueText(this.currentElettricaFiglia, 'fotoInverter') ?? 'todo') as BoxStatusType;
      this.fotoInverterAlt = getLeadCustomValueText(this.currentElettricaFiglia, 'fotoInverterAlt') ?? null;
      this.fotoBatteria = (getLeadCustomValueText(this.currentElettricaFiglia, 'fotoBatteria') ?? 'todo') as BoxStatusType;
      this.fotoBatteriaAlt = getLeadCustomValueText(this.currentElettricaFiglia, 'fotoBatteriaAlt') ?? null;

      this.docsSentToPartner = getLeadCustomValueBoolean(this.currentElettricaFiglia, 'docsSentToPartner') ?? false;
    }
  }
}
